import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import './ERidesFAQ.scss';

const FAQ_DATA = [
  {
    q: (
      <FormattedMessage
        id="ae-erides-faq1"
        defaultMessage="✅ Low Cost, High Value"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-faq1A"
        defaultMessage="Electric bikes and scooters cost far less than cars and require minimal upkeep. No gas, no oil changes—just plug in and go."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-erides-faq2"
        defaultMessage="🚦 Beat the Traffic"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-faq2A"
        defaultMessage="E-Rides help you skip the congestion and get around faster on bike lanes and urban trails."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-erides-faq3"
        defaultMessage="🌎 Eco-Friendly Choice "
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-faq3A"
        defaultMessage="Every ride on an e-bike or scooter helps reduce carbon emissions and air pollution—good for you and for Austin."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-erides-faq4"
        defaultMessage="🅿️ No Parking Stress"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-faq4A"
        defaultMessage="Forget circling for a spot or paying for downtown parking. E-Rides can be stored at home or locked at any bike rack."
      />
    ),
  },
  {
    q: (
      <FormattedMessage
        id="ae-erides-faq5"
        defaultMessage="🔋 Perfect for Short Trips"
      />
    ),
    a: (
      <FormattedMessage
        id="ae-erides-faq5A"
        defaultMessage="Whether it's commuting a few miles, grabbing groceries, or enjoying a scenic ride along Lady Bird Lake, E-Rides make short trips fun."
      />
    ),
  },
];

const Chevron = ({ expanded }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 24 24"
    style={{
      transition: 'transform 180ms ease',
      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    }}
  >
    <path
      d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
      fill="currentColor"
    />
  </svg>
);

const FAQItem = ({ idBase, index, q, a, expanded, onToggle }) => {
  const buttonId = `${idBase}-faq-button-${index}`;
  const panelId = `${idBase}-faq-panel-${index}`;

  return (
    <div className="faq-item border rounded-3 mb-2">
      <h3 className="m-0">
        <button
          id={buttonId}
          className="faq-trigger w-100 d-flex align-items-center justify-content-between text-start p-3 border-0 bg-white"
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={onToggle}
        >
          <span className="pe-3">{q}</span>
          <Chevron expanded={expanded} />
        </button>
      </h3>

      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        hidden={!expanded}
        className="faq-panel px-3 pb-3"
      >
        <p className="mb-0">{a}</p>
      </div>
    </div>
  );
};

const ERidesFAQ = () => {
  const [open, setOpen] = useState(() => new Set());
  const idBase = useRef(
    `faq-${Math.random().toString(36).slice(2, 9)}`
  ).current;

  const toggle = (i) =>
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(i) ? next.delete(i) : next.add(i);
      return next;
    });

  return (
    <section className="erides-faq-container container" aria-label="ERides FAQ">
      <div className="faq-title">
        <h2 className="mb-2">
          <FormattedMessage
            id="erides.faqTitle"
            defaultMessage="Why E-Rides Are a Smart Investment"
          />
        </h2>
        <p>
          <FormattedMessage
            id="erides.faqDescription"
            defaultMessage="E-Rides are more than just fun—they're a practical, affordable way to get around Austin."
          />
        </p>
      </div>

      <div className="faq-list mt-4">
        {FAQ_DATA.map((item, i) => (
          <FAQItem
            key={i}
            idBase={idBase}
            index={i}
            q={item.q}
            a={item.a}
            expanded={open.has(i)}
            onToggle={() => toggle(i)}
          />
        ))}
      </div>

      <style>{`
        .faq-item:hover .faq-trigger { background-color: #f8f9fa; }
        .faq-trigger { font-size: 1rem; }
        .faq-panel { background-color: #fff; }
      `}</style>
    </section>
  );
};

export default ERidesFAQ;
